import { useQuery } from '@tanstack/react-query';
import { CommonKey } from '../../types/api';
import sportsApi from '../../utils/sportsApi';
import * as fns from 'date-fns';

const getReport = async (client, filters) => {
    if (!filters) return;

    const query = {
        action: 'fetchQuery',
        domainObject: {
            client: {
                id: client.id,
            },
            startDate: fns.format(new Date(0), "yyyy-MM-dd'T'HH:mm:ss.SSSXXX"),
            ...filters,
            pageSize: 20,
        },
    };

    const endpoint = `/media-uploads/broadcasts`;

    return await sportsApi.url(endpoint).json(query).post().json();
};

export const useBroadcastExposures = (client, query) =>
    useQuery({
        queryKey: [CommonKey.BroadcastPosts, query],
        queryFn: () => getReport(client, query),
        staleTime: 240000,
    });
